import type { ReactElement } from 'react';

import { PrivateShowRequestsCard } from '../dashboard/PrivateShowRequestsCard.js';
import { SettingsStack } from './SettingsStack.js';

export function SettingsRequestsPage(): ReactElement {
  return (
    <SettingsStack
      titleKey="common.studio.settings.requestsTitle"
      hintKey="common.studio.settings.requestsHint"
    >
      <PrivateShowRequestsCard />
    </SettingsStack>
  );
}
